import { render, staticRenderFns } from "./LicenseButton.vue?vue&type=template&id=6492ef10&"
import script from "./LicenseButton.vue?vue&type=script&lang=ts&"
export * from "./LicenseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports